export interface Category {
  name: string;
  url: string;
  itemCount: string;
  imageUrl: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    itemCount: '2,400+ items',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fashion%20sneakers%20and%20designer%20shoes%20on%20warm%20cream%20minimal%20background%2C%20soft%20diffused%20studio%20lighting%2C%20editorial%20product%20photography%2C%20warm%20beige%20neutral%20tones%2C%20clean%20composition%2C%20soft%20shadows%2C%20elegant%20presentation%2C%20organic%20textures%2C%20no%20text%2C%20sophisticated%20style&width=600&height=400&seq=cat-shoes-01&orientation=landscape',
  },
  {
    name: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    itemCount: '1,800+ items',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20hoodies%20and%20sweaters%20on%20warm%20cream%20minimal%20background%2C%20soft%20diffused%20studio%20lighting%2C%20editorial%20product%20photography%2C%20warm%20neutral%20beige%20tones%2C%20cozy%20casual%20fashion%2C%20clean%20composition%2C%20soft%20shadows%2C%20organic%20textures%2C%20no%20text%2C%20lifestyle%20aesthetic&width=600&height=400&seq=cat-hoodies-02&orientation=landscape',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    itemCount: '3,100+ items',
    imageUrl: 'https://readdy.ai/api/search-image?query=Trendy%20t-shirts%20and%20graphic%20tees%20on%20warm%20cream%20minimal%20background%2C%20soft%20diffused%20studio%20lighting%2C%20editorial%20product%20photography%2C%20warm%20neutral%20tones%2C%20streetwear%20style%2C%20clean%20composition%2C%20soft%20shadows%2C%20organic%20textures%2C%20no%20text&width=600&height=400&seq=cat-tshirts-03&orientation=landscape',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    itemCount: '1,500+ items',
    imageUrl: 'https://readdy.ai/api/search-image?query=Designer%20jackets%20and%20outerwear%20on%20warm%20cream%20minimal%20background%2C%20soft%20diffused%20studio%20lighting%2C%20editorial%20product%20photography%2C%20warm%20neutral%20beige%20tones%2C%20sophisticated%20style%2C%20clean%20composition%2C%20soft%20shadows%2C%20organic%20textures%2C%20no%20text&width=600&height=400&seq=cat-jackets-04&orientation=landscape',
  },
  {
    name: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    itemCount: '2,000+ items',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fashionable%20pants%20and%20shorts%20on%20warm%20cream%20minimal%20background%2C%20soft%20diffused%20studio%20lighting%2C%20editorial%20product%20photography%2C%20warm%20neutral%20tones%2C%20casual%20style%2C%20clean%20composition%2C%20soft%20shadows%2C%20organic%20textures%2C%20no%20text&width=600&height=400&seq=cat-pants-05&orientation=landscape',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    itemCount: '900+ items',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20caps%20hats%20and%20headwear%20on%20warm%20cream%20minimal%20background%2C%20soft%20diffused%20studio%20lighting%2C%20editorial%20product%20photography%2C%20warm%20neutral%20tones%2C%20clean%20composition%2C%20soft%20shadows%2C%20organic%20textures%2C%20no%20text&width=600&height=400&seq=cat-headwear-06&orientation=landscape',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    itemCount: '600+ items',
    imageUrl: 'https://readdy.ai/api/search-image?query=Coordinated%20fashion%20outfit%20sets%20on%20warm%20cream%20minimal%20background%2C%20soft%20diffused%20studio%20lighting%2C%20editorial%20product%20photography%2C%20warm%20neutral%20tones%2C%20matching%20ensembles%2C%20clean%20composition%2C%20soft%20shadows%2C%20organic%20textures%2C%20no%20text&width=600&height=400&seq=cat-sets-07&orientation=landscape',
  },
  {
    name: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    itemCount: '750+ items',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20underwear%20and%20basics%20on%20warm%20cream%20minimal%20background%2C%20soft%20diffused%20studio%20lighting%2C%20editorial%20product%20photography%2C%20warm%20neutral%20tones%2C%20clean%20minimal%20style%2C%20soft%20shadows%2C%20organic%20textures%2C%20no%20text&width=600&height=400&seq=cat-underwear-08&orientation=landscape',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    itemCount: '1,100+ items',
    imageUrl: 'https://readdy.ai/api/search-image?query=Sports%20jersey%20and%20athletic%20wear%20on%20warm%20cream%20minimal%20background%2C%20soft%20diffused%20studio%20lighting%2C%20editorial%20product%20photography%2C%20warm%20neutral%20tones%2C%20sporty%20style%2C%20clean%20composition%2C%20soft%20shadows%2C%20organic%20textures%2C%20no%20text&width=600&height=400&seq=cat-jersey-09&orientation=landscape',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    itemCount: '2,200+ items',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20fashion%20accessories%20watches%20jewelry%20on%20warm%20cream%20minimal%20background%2C%20soft%20diffused%20studio%20lighting%2C%20editorial%20product%20photography%2C%20warm%20neutral%20tones%2C%20elegant%20style%2C%20clean%20composition%2C%20soft%20shadows%2C%20organic%20textures%2C%20no%20text&width=600&height=400&seq=cat-accessories-10&orientation=landscape',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    itemCount: '1,300+ items',
    imageUrl: 'https://readdy.ai/api/search-image?query=Designer%20handbags%20and%20backpacks%20on%20warm%20cream%20minimal%20background%2C%20soft%20diffused%20studio%20lighting%2C%20editorial%20product%20photography%2C%20warm%20neutral%20tones%2C%20luxury%20style%2C%20clean%20composition%2C%20soft%20shadows%2C%20organic%20textures%2C%20no%20text&width=600&height=400&seq=cat-bags-11&orientation=landscape',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    itemCount: '500+ items',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20leather%20belts%20and%20designer%20belts%20on%20warm%20cream%20minimal%20background%2C%20soft%20diffused%20studio%20lighting%2C%20editorial%20product%20photography%2C%20warm%20neutral%20tones%2C%20clean%20composition%2C%20soft%20shadows%2C%20organic%20textures%2C%20no%20text&width=600&height=400&seq=cat-belts-12&orientation=landscape',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    itemCount: '400+ items',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20perfume%20bottles%20and%20fragrances%20on%20warm%20cream%20minimal%20background%2C%20soft%20diffused%20studio%20lighting%2C%20editorial%20product%20photography%2C%20warm%20neutral%20tones%2C%20elegant%20style%2C%20clean%20composition%2C%20soft%20shadows%2C%20organic%20textures%2C%20no%20text&width=600&height=400&seq=cat-perfumes-13&orientation=landscape',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    itemCount: '1,000+ items',
    imageUrl: 'https://readdy.ai/api/search-image?query=Miscellaneous%20fashion%20items%20and%20accessories%20on%20warm%20cream%20minimal%20background%2C%20soft%20diffused%20studio%20lighting%2C%20warm%20neutral%20tones%2C%20clean%20composition%2C%20soft%20shadows%2C%20organic%20textures%2C%20no%20text&width=600&height=400&seq=cat-other-14&orientation=landscape',
  },
];

export const trustStats = [
  { value: '50,000+', label: 'Active Users' },
  { value: 'Daily', label: 'Updated Spreadsheets' },
  { value: '14,000+', label: 'Verified Products' },
  { value: '2,500+', label: 'Trusted Sellers' },
];